import { BaseCard } from '@/interfaces/baseCard';

const BASE_URL: string = `${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks`;

export const earningsData: {
  kube: BaseCard[];
  default: BaseCard[];
  ice: BaseCard[];
} = {
  default: [
    {
      title: 'earnings.1.title',
      description: 'earnings.1.description',
      image: `${BASE_URL}/earnings/1.webp`,
    },
    {
      title: 'earnings.2.title',
      description: 'earnings.2.description',
      image: `${BASE_URL}/earnings/2.webp`,
    },
    {
      title: 'earnings.3.title',
      description: 'earnings.3.description',
      image: `${BASE_URL}/earnings/3.webp`,
    },
    {
      title: 'earnings.4.title',
      description: 'earnings.4.description',
      image: `${BASE_URL}/earnings/4.webp`,
    },
  ],
  kube: [
    {
      title: 'earnings.1.title',
      description: 'earnings.1.description',
      image: `${BASE_URL}/kube/banner-indique-ganhe-etapa1PNG.png`,
    },
    {
      title: 'earnings.2.title',
      description: 'earnings.2.description',
      image: `${BASE_URL}/kube/banner-indique-ganhe-etapa2PNG.png`,
    },
    {
      title: 'earnings.3.title',
      description: 'earnings.3.description',
      image: `${BASE_URL}/kube/banner-indique-ganhe-etapa3PNG.png`,
    },
    {
      title: 'earnings.4.title',
      description: 'earnings.4.description',
      image: `${BASE_URL}/kube/banner-indique-ganhe-etapa4PNG.png`,
    },
  ],
  ice: [
    {
      title: 'earnings.1.title',
      description: 'earnings.1.description',
      image: `${BASE_URL}/ice/affiliates-cards-art-1.png`,
    },
    {
      title: 'earnings.2.title',
      description: 'earnings.2.description',
      image: `${BASE_URL}/ice/affiliates-cards-art-2.png`,
    },
    {
      title: 'earnings.3.title',
      description: 'earnings.3.description',
      image: `${BASE_URL}/ice/affiliates-cards-art-3.png`,
    },
    {
      title: 'earnings.4.title',
      description: 'earnings.4.description',
      image: `${BASE_URL}/ice/affiliates-cards-art-4.png`,
    },
  ],
};
